import { IconPack } from "SuperAdmin/Config/Icon";
import styles from "./Roles.module.scss";
const Roles = ({ form, setOpenCreateRole }) => {
  const handleDeleteRole = (role) => {
    const foundItem = form.getFieldsValue().role.find((item, index) => {
      if (role.id) {
        if (item.id === role.id) {
          return true;
        } else {
          return false;
        }
      } else {
        if (item.name === role.name) {
          return true;
        } else {
          return false;
        }
      }
    });
    if (foundItem) {
    }
  };
  const Role = ({ role, index }) => {
    return (
      <div
        className={styles["role"]}
        key={index}
        style={{
          border: `1px solid ${
            role.type == 1
              ? "var(--institution-role)"
              : role.type == 2
              ? "var(--unit-role)"
              : "var(--personal-role)"
          }`,
        }}
      >
        <div className={styles["information"]}>
          <div className={styles["type"]}>
            <p
              style={{
                color:
                  role.type == 1
                    ? "var(--institution-role)"
                    : role.type == 2
                    ? "var(--unit-role)"
                    : "var(--personal-role)",
              }}
            >
              {role.type == 1
                ? "Institution"
                : role.type == 2
                ? "Unit"
                : "Personal profile"}
            </p>
          </div>

          {role.type == 3 && (
            <div className={styles["role-info-personal"]}>
              <p className={styles["name"]}>{form.getFieldsValue()?.name}</p>
              <p>{form.getFieldsValue()?.institution}</p>
              <p>{form.getFieldsValue()?.position}</p>
            </div>
          )}
          {role.type != 3 && (
            <div className={styles["role-info"]}>
              <p className={styles["name"]}>
                Unit: {role.management_scope_name}
              </p>
              <div className={styles["unit-permissions"]}>
                <p>
                  Permissions:{" "}
                  {role?.permissions?.map((item, key) => {
                    return <span key={key}>{`${item}, `}</span>;
                  })}
                </p>
              </div>
            </div>
          )}
        </div>
        {role.type != 3 && (
          <div
            className={styles["delete-role"]}
            onClick={handleDeleteRole(role)}
          >
            {IconPack.close_icon}
          </div>
        )}
      </div>
    );
  };
  return (
    <div className={styles["roles"]}>
      <div className={styles["account-roles"]}>
        {form.getFieldsValue()?.role?.map((item, index) => {
          return <Role role={item} key={index} index={index} />;
        })}
      </div>
      <div
        className={styles["add-more-role"]}
        onClick={() => setOpenCreateRole(true)}
      >
        {IconPack.add_icon}
      </div>
    </div>
  );
};

export default Roles;
